import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker. Only in production builds — in dev (`yarn
// start`), the SW would cache hot-reload artefacts and break the workflow.
// Production-only registration is the safe default.
//
// Stuck on old code? Open https://pulse.optygo.ai/?reset_sw=1 — the SW
// will unregister itself and clear all caches.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[Pulse SW] registration failed:", err);
      });
  });
}
